"use client";

import { Icon } from "@astryxdesign/core/Icon";
import { IconButton } from "@astryxdesign/core/IconButton";
import { useColorMode } from "@/components/app/color-mode-provider";
import {
  nextColorMode,
  type ColorMode,
} from "@/lib/theme/color-mode";
import { researchIcons, type ResearchIconName } from "@/lib/icons/research-icons";

const MODE_META: Record<
  ColorMode,
  { label: string; nextLabel: string; icon: ResearchIconName }
> = {
  system: {
    label: "Системная тема",
    nextLabel: "Переключить на светлую тему",
    icon: "monitor",
  },
  light: {
    label: "Светлая тема",
    nextLabel: "Переключить на тёмную тему",
    icon: "sun",
  },
  dark: {
    label: "Тёмная тема",
    nextLabel: "Переключить на системную тему",
    icon: "moon",
  },
};

type Props = {
  compact?: boolean;
};

/** Одна кнопка: system → light → dark → system */
export function ThemeModeSwitch({ compact = false }: Props) {
  const { mode, setMode } = useColorMode();
  const meta = MODE_META[mode];

  return (
    <IconButton
      label={`${meta.label}. ${meta.nextLabel}`}
      size={compact ? "sm" : "md"}
      variant="ghost"
      icon={
        <Icon icon={researchIcons[meta.icon]} size="sm" color="secondary" />
      }
      onClick={() => setMode(nextColorMode(mode))}
    />
  );
}
